import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './styles';
import { Button } from 'antd';

export const RBHButton = (props: any) => {
  let style = props.style;
  if (props.disabled) {
    style = { ...props.style, ...styles.disabled };
  }

  return (
    <Button {...props} style={style}>
      {props.text ? <FormattedMessage id={props.text} /> : null}
      {props.children}
    </Button>
  );
};

export default RBHButton;
